import React, { useEffect, useState } from "react";
import "../Orders/Orders.css";
import "./SubDistributorsMenu.css";
import "../Inventory/Inventory.css";
import { FaArrowLeftLong } from "react-icons/fa6";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { IoEyeOutline } from "react-icons/io5";
import { ToastContainer, toast } from "react-toastify";
import Stack from "@mui/material/Stack";
import CircularProgress from "@mui/material/CircularProgress";
import { Formik, useFormik } from "formik";
import { axiosInstance } from "../../../axiosInstance";
import { IoClose } from "react-icons/io5";
import { GoSearch } from "react-icons/go";
import * as yup from "yup";
import TablePagination from "@mui/material/TablePagination";

function createData3(date, mode, amount, status) {
  return {
    date,
    mode,
    amount,
    status,
  };
}

const rows3 = [
  createData3("05-Sep-2025", "UPI", "₹45,000", "Received"),
  createData3("05-Sep-2025", "UPI", "₹45,000", "Received"),
  createData3("05-Sep-2025", "UPI", "₹45,000", "Received"),
  createData3("05-Sep-2025", "UPI", "₹45,000", "Received"),
];
export const ViewSubDistributors = () => {
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const { Id } = location.state || "";
  console.log("Id", Id);
  const navigate = useNavigate();

  const [activeMenu, setactiveMenu] = useState("recent");
  function handleSelectMenu(menu) {
    setactiveMenu(menu);
  }
  // recent reorder table pagination
  const [recentpage, setRecentPage] = useState(0);
  const [recentrowsPerPage, setRecentRowsPerPage] = useState(5);
  const [recenttotalCount, setRecentTotalCount] = useState(0);

  const handleChangeRecentRowsPerPage = (event) => {
    setRecentRowsPerPage(+event.target.value);
    setRecentPage(0); // reset to first page
  };
  const [recentOrdersData, setRecentOrdersData] = useState({});
  async function FetchRecentOrdersData(Id) {
    try {
      setLoading(true);
      const response = await axiosInstance.get(
        `/distributor/subdistributor-recent-order/${Id}/`,
      );
      if (response.data.status === "Success") {
        setRecentOrdersData(response.data?.data);
        setRecentTotalCount(response.data.data?.count);
        console.log("Recent Orders data fetched successfully");
      }
    } catch (error) {
      toast.error(
        error.response.data.message || "Failed to fetch recent orders data",
      );
      console.log("Failed to fetch recent orders data");
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    FetchRecentOrdersData(Id);
  }, [Id, recentpage, recentrowsPerPage]);
  // stock table pagination
  const [stockpage, setStockPage] = useState(0);
  const [stockrowsPerPage, setStockRowsPerPage] = useState(5);
  const [stocktotalCount, setStockTotalCount] = useState(0);

  const handleChangeStockRowsPerPage = (event) => {
    setStockRowsPerPage(+event.target.value);
    setStockPage(0); // reset to first page
  };
  const [stockData, setStockData] = useState({});
  async function FetchStockAtSubdistributor(Id) {
    try {
      setLoading(true);
      const response = await axiosInstance.get(
        `/distributor/subdistributor-stock-list/${Id}/`,
      );
      if (response.data.status === "Success") {
        setStockData(response.data.data);
        setStockTotalCount(response.data?.data.count);
        console.log("Stock data fetched successfully");
      }
    } catch (error) {
      toast.error(error.response.data.message || "Failed to fetch stock data");
      console.log("Failed to fetch stock data");
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    FetchStockAtSubdistributor(Id);
  }, [Id, stockpage, stockrowsPerPage]);

  return (
    <>
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(0, 0, 0, 0.3)",
            zIndex: 9999,
          }}
        >
          <Stack spacing={2} direction="row" alignItems="center">
            <CircularProgress size={40} sx={{ color: "var(--color-theme)" }} />
          </Stack>
        </div>
      )}
      <ToastContainer />
      <div className="ordersContainer">
        <div className="container">
          <div className="d-flex gap-1 mb-2">
            <span className="me-2">
              <Link to="/state-sub-distributors" style={{ color: "black" }}>
                <FaArrowLeftLong />
              </Link>
            </span>
            <div className="inventoryTitle">
              {recentOrdersData?.subdistributor_card?.business_name ?? "---"}
            </div>
          </div>
          <div className="inventorySubtitle">
            Review and process this sub-distributor order
          </div>
          {/* cards section  */}
          <div className="manageCardsGrid">
            <div className="manageCard">
              <div>Contact Person</div>
              <div>
                {recentOrdersData?.subdistributor_card?.contact_person ?? "---"}
              </div>
            </div>
            <div className="manageCard">
              <div>Phone</div>
              <div>{recentOrdersData?.subdistributor_card?.phone ?? "---"}</div>
            </div>
            <div className="manageCard">
              <div>Email</div>
              <div>{recentOrdersData?.subdistributor_card?.email ?? "---"}</div>
            </div>
            <div className="manageCard">
              <div>Location</div>
              <div>
                {recentOrdersData?.subdistributor_card?.location ?? "---"}
              </div>
            </div>
            <div className="manageCard">
              <div>Outstanding Dues</div>
              <div>
                ₹{" "}
                {recentOrdersData?.subdistributor_card?.outstanding_dues ??
                  "---"}
              </div>
            </div>
            <div className="manageCard">
              <div>Total Orders</div>
              <div>
                {recentOrdersData?.subdistributor_card?.total_order ?? "---"}
              </div>
            </div>
          </div>
          {/* table menu  */}
          <div className="inventoryFilterContainer">
            <div className="inventoryMenu">
              <div
                onClick={() => handleSelectMenu("recent")}
                className={`menuTitle ${
                  activeMenu === "recent" ? "active" : ""
                }`}
              >
                Recent Orders
              </div>
              <div
                onClick={() => handleSelectMenu("stock")}
                className={`menuTitle ${
                  activeMenu === "stock" ? "active" : ""
                }`}
              >
                Stock at Sub-Distributor
              </div>
              <div
                onClick={() => handleSelectMenu("payment")}
                className={`menuTitle ${
                  activeMenu === "payment" ? "active" : ""
                }`}
              >
                Payment History
              </div>
            </div>
            <div className="inventoryFilters">{""}</div>
          </div>

          {/* recent table  */}
          {activeMenu === "recent" && (
            <div className="dashboardTableContainer">
              <TableContainer component={Paper}>
                <Table
                  // sx={{ minWidth: 650 }}
                  stickyHeader
                  aria-label="sticky table"
                >
                  <TableHead className="dashboadTableHeader">
                    <TableRow>
                      <TableCell align="left">Order ID</TableCell>
                      <TableCell align="left">Date</TableCell>
                      <TableCell align="left">Status</TableCell>
                      <TableCell align="left">Amount (₹)</TableCell>
                      <TableCell align="left">Actions</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {recentOrdersData?.results?.length > 0 ? (
                      recentOrdersData?.results?.map((row) => (
                        <TableRow
                          key={row.name}
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                          className="dashboardTableBody"
                        >
                          <TableCell align="left">{row.order_id}</TableCell>
                          <TableCell align="left">{row.order_date}</TableCell>

                          <TableCell
                            align="left"
                            style={{
                              color: (() => {
                                switch (row.status) {
                                  case "Pending":
                                  case "PENDING":
                                    return "#EF4444";

                                  case "Delivered":
                                  case "DELIVERED":
                                    return "#10B981";
                                  default:
                                    return "var(--color-font-secondary)";
                                }
                              })(),
                            }}
                          >
                            {row.status}
                          </TableCell>
                          <TableCell align="left">{row.total_amount}</TableCell>

                          <TableCell align="left">
                            {row.status === "Pending" ? (
                              <button
                                className="btnTableManage"
                                onClick={() =>
                                  navigate("/state-orders-manage", {
                                    state: { Id: row.order_id },
                                  })
                                }
                              >
                                Manage
                              </button>
                            ) : (
                              <IoEyeOutline
                                style={{ cursor: "pointer" }}
                                onClick={() =>
                                  navigate("/state-invoice-view", {
                                    state: { Id: row.invoice_id },
                                  })
                                }
                              />
                            )}
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell
                          colSpan={5}
                          align="center"
                          style={{ padding: "20px" }}
                        >
                          Data not available
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                component="div"
                count={recenttotalCount}
                page={recentpage}
                onPageChange={(event, newPage) => setRecentPage(newPage)}
                rowsPerPage={recentrowsPerPage}
                rowsPerPageOptions={[5, 10, 20, 50]} //dropdown
                onRowsPerPageChange={handleChangeRecentRowsPerPage}
              />
            </div>
          )}
          {/* stock table  */}
          {activeMenu === "stock" && (
            <div className="dashboardTableContainer">
              <TableContainer component={Paper}>
                <Table
                  // sx={{ minWidth: 650 }}
                  stickyHeader
                  aria-label="sticky table"
                >
                  <TableHead className="dashboadTableHeader">
                    <TableRow>
                      <TableCell align="left">Product Name</TableCell>
                      <TableCell align="left">Current Stock</TableCell>
                      <TableCell align="left">Last Re-ordered</TableCell>
                      <TableCell align="left">Last Order Qty</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {stockData?.results?.length > 0 ? (
                      stockData?.results?.map((row) => (
                        <TableRow
                          key={row.name}
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                          className="dashboardTableBody"
                        >
                          <TableCell align="left">
                            {row.product_name ?? "---"}
                          </TableCell>
                          <TableCell align="left">
                            {row.current_stock ?? "---"}
                          </TableCell>

                          <TableCell align="left">
                            {row.last_re_ordered ?? "---"}
                          </TableCell>
                          <TableCell align="left">
                            {row.last_order_qty ?? "---"}
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell
                          colSpan={4}
                          align="center"
                          style={{ padding: "20px" }}
                        >
                          Data not available
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                component="div"
                count={stocktotalCount}
                page={stockpage}
                onPageChange={(event, newPage) => setStockPage(newPage)}
                rowsPerPage={stockrowsPerPage}
                rowsPerPageOptions={[5, 10, 20, 50]} //dropdown
                onRowsPerPageChange={handleChangeStockRowsPerPage}
              />
            </div>
          )}
          {/* payment history  */}
          {activeMenu === "payment" && (
            <div className="dashboardTableContainer">
              <TableContainer component={Paper}>
                <Table
                  // sx={{ minWidth: 650 }}
                  stickyHeader
                  aria-label="sticky table"
                >
                  <TableHead className="dashboadTableHeader">
                    <TableRow>
                      <TableCell align="left">Date</TableCell>
                      <TableCell align="left">Mode</TableCell>
                      <TableCell align="left">Amount</TableCell>
                      <TableCell align="left">Staus</TableCell>
                    </TableRow>
                  </TableHead>
                  {/* <TableBody>
                    {rows3.map((row) => (
                      <TableRow
                        key={row.name}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                        className="dashboardTableBody"
                      >
                        <TableCell align="left">{row.date}</TableCell>
                        <TableCell align="left">{row.mode}</TableCell>

                        <TableCell align="left">{row.amount}</TableCell>
                        <TableCell
                          align="left"
                          style={{
                            color: (() => {
                              switch (row.status) {
                                case "Received":
                                  return "#10B981";
                                default:
                                  return "var(--color-font-secondary)";
                              }
                            })(),
                          }}
                        >
                          {row.status}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody> */}
                  <TableBody>
                    <TableRow>
                      <TableCell
                        colSpan={4}
                        align="center"
                        style={{ padding: "20px" }}
                      >
                        Data not available
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          )}
        </div>
      </div>
    </>
  );
};
